import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, patchData } from "src/utils/axios/serverHelper";
import { HRM3130_R01Dto, HRM3130_R01TaxTableDto, HRM3130_R01TaxDto, HRM3130_R01SurchargeRuleDto } from "./Dto_HRM3130_R01";
import { HRM3130_R01Filter } from "./Store_HRM3130_R01";
const baseUrl = `${config.apiUrl}/HRM3130_R01`; // 화면 공통 API 경로
/** 옵션과 연도 조건으로 전체 목록 응답을 반환한다. */
export const getHRM3130_R01List = (option: string, params: Partial<HRM3130_R01Filter>, listLength = 0) =>
    getData<ResponseDto<HRM3130_R01TaxTableDto[]>>(`${baseUrl}/${option}`, { params: { applyYear: params.applyYear, listLength } });
/** 등록 연도 목록 응답을 반환한다. */
export const getHRM3130_R01YearList = () => getData<ResponseDto<string[]>>(`${baseUrl}/years`);
/** 공용 가산 산식 목록 응답을 반환한다. */
export const getHRM3130_R01SurchargeRuleList = () => getData<ResponseDto<HRM3130_R01SurchargeRuleDto[]>>(`${baseUrl}/surchargeRule`);
/** 연도·급여·가족수에 따른 서버 계산 응답을 반환한다. */
export const getHRM3130_R01IncomeTax = (params: { applyYear: string; taxableAmt: number; familyCount: number }) =>
    getData<ResponseDto<HRM3130_R01TaxDto>>(`${baseUrl}/incomeTax`, { params });
/** 해당 연도 전체 교체 결과 응답을 반환한다. */
export const patchHRM3130_R01 = (data: HRM3130_R01Dto) =>
    patchData<HRM3130_R01Dto, ResponseDto<HRM3130_R01Dto>>(baseUrl, data);
/** 조회 연도의 엑셀 파일 응답을 반환한다. */
export const downloadExcel_HRM3130_R01 = (option: string, params: Partial<HRM3130_R01Filter>) =>
    getData<ResponseDto<string>>(`${baseUrl}/excel/${option}`, { params: { applyYear: params.applyYear } });
